import { render, staticRenderFns } from "./WApp.vue?vue&type=template&id=39af84dc&"
import script from "./WApp.vue?vue&type=script&lang=js&"
export * from "./WApp.vue?vue&type=script&lang=js&"
import style0 from "./WApp.vue?vue&type=style&index=0&id=39af84dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports